import { useAppDispatch } from 'hooks'
import { useSelector } from 'react-redux'
import { LeagueSwitch } from '../../Filters.model'
import { setFilterIsOverall } from '../../state/Filters.reducer'
import { getIsOverall } from '../../state/Filters.selectors'
import * as Styled from './FiltersLeagueSwitch.styled'

export function FiltersLeagueSwitch() {
  const dispatch = useAppDispatch()

  const tabs = [LeagueSwitch.OVERALL, LeagueSwitch.LEAGUE]
  const isOverall = useSelector(getIsOverall)
  const activeTab = isOverall ? LeagueSwitch.OVERALL : LeagueSwitch.LEAGUE

  const handleTabChange = (tab: LeagueSwitch) => () => {
    dispatch(setFilterIsOverall(tab === LeagueSwitch.OVERALL))
  }

  return (
    <Styled.Tabs>
      {tabs.map((tab) => (
        <Styled.Tab key={tab} $active={activeTab === tab} onClick={handleTabChange(tab)}>
          {tab}
        </Styled.Tab>
      ))}
    </Styled.Tabs>
  )
}
